module.exports = __webpack_public_path__ + "media/Tapping Copy Button.0aa12a04.mp3";